import { notification } from 'antd'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'

import { TruckDocumentationApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al actualizar un camión',
  })
}

const useUpdateTruckDocumentation = () => {
  const navigate = useNavigate()

  const onSuccess = () => {
    notification.success({
      message: 'Camión actualizado con éxito',
    })
    navigate('/dashboard/suppliers')
  }

  const { mutate, isLoading } = useMutation(TruckDocumentationApi.updateTruckDocumentation, {
    onSuccess,
    onError,
  })

  return {
    updateTruckDocumentation: mutate,
    isLoading,
  }
}

export { useUpdateTruckDocumentation }
